<!--
  name : 김혜진
  desc : 로그인
  date : 2020-11-10
-->
<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" class="login_main_title">로그인</v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center" class="row_mb-40">
			<v-form autocomplete="on" :model="loginForm" ref="loginForm">
      <v-card id="popStyle02" class="popW472">
        <!--<v-btn fab class="popBtnClose"></v-btn>-->
        <v-card-text>
          <v-row no-gutters class="w350">
            <v-col cols="12">
              <v-text-field class="inputH48_01"
            		v-model="loginForm.username"
                label="아이디"
                placeholder=" "
								:rules="nameRules"
                outlined
                dense
								autoComplete="on"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field class="inputH48_01"
                label="비밀번호"
								v-model="loginForm.password"
                placeholder=" "
								:rules="passwordRules"
                outlined
                dense
								autoComplete="on"
								:type="'password'"
                @keyup.enter="handleLogin"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="ta_left mb-6">
              <v-checkbox class="coNlist_chk size_s"
                label="아이디 저장"
								v-model="saveid"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="mb-2"><v-btn text class="btn19_C01 btn_only" @click.native.prevent="handleLogin">로그인</v-btn></v-col>
            <v-col cols="12"><v-btn outlined class="btn19_00 btn_only" @click="goJoin">회원가입</v-btn></v-col>
            <v-col cols="12">
              <ul class="pattern_ul_bar mt-6">
                <li><v-btn text class="btn_txt" @click="dialog01 = true">아이디 찾기</v-btn></li>
                <li><v-btn text class="btn_txt" @click="dialog01 = true">비밀번호 찾기</v-btn></li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
			</v-form>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <!--(팝업)개인 정보-->
    <v-dialog
      v-model="dialog01"
      max-width="472px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          <div class="popCon_txt">
              <v-tabs class="popSet_userinfo"
               v-model="tab">
                <v-tab href="#tab-1" @click="hidden = !hidden">아이디 찾기</v-tab>
                <v-tab href="#tab-2" @click="hidden = !hidden">비밀번호 찾기</v-tab>
              </v-tabs>
            </div>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-tabs-items v-model="tab">
              <v-tab-item
                value="tab-1"
              >
							<v-form autocomplete="on" :model="FindIdInfo" ref="FindIdInfo">
                <div class="popCon_txt ta_center">사용자이름과 이메일을 입력해주세요.</div>
                <div class="popCon_input_W350_cov">
                  <v-text-field class="inputH48_01 conBstar"
									  v-model="FindIdInfo.userName"
										:rules="nameRules"
                    label="이름"
                    placeholder="이름 입력"
                    outlined
                    dense
                  >
                  </v-text-field>
                  <v-text-field class="inputH48_01 conBstar"
										v-model="FindIdInfo.userEmail"
										:rules="emailRules"
                    label="이메일"
                    placeholder="이메일 입력"
                    outlined
                    dense
                  >
                  </v-text-field>
                </div>
								<p v-if="findUsrId != ''" class="join_txt01" style="margin-bottom:0px;">요청하신 아이디(ID)는 <font style="color:blue">{{findUsrId}}</font> 입니다.</p>
							</v-form>
              </v-tab-item>
              <v-tab-item
                value="tab-2"
              >
								<v-form autocomplete="on" :model="FindPassInfo" ref="FindPassInfo">
                <div class="popCon_txt">가입 정보와 입력하신 정보가 일치하면 해당 이메일로 임시 비밀번호가 발급됩니다.</div>
                <div class="popCon_input_W350_cov">
                  <v-text-field class="inputH48_01 conBstar"
										v-model="FindPassInfo.userId"
										:rules="nameRules"
                    label="아이디"
                    placeholder="아이디 입력"
                    outlined
                    dense
                  >
                  </v-text-field>
                  <v-text-field class="inputH48_01 conBstar"
										v-model="FindPassInfo.userName"
										:rules="nameRules"
                    label="이름"
                    placeholder="이름 입력"
                    outlined
                    dense
                  >
                  </v-text-field>
                  <v-text-field class="inputH48_01 conBstar"
										v-model="FindPassInfo.userEmail"
										:rules="emailRules"
                    label="이메일"
                    placeholder="이메일 입력"
                    outlined
                    dense
                  >
                  </v-text-field>
                </div>
								</v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <!--회원탈퇴 tab 누를시만 버튼 네임 변경-->
          <v-btn class="btn_C01" text v-if="hidden" @click="submitPassForm">임시 비밀번호 발급</v-btn>
					<v-btn class="btn_C01" text v-else @click="submitIdForm">아이디 찾기</v-btn>
          <v-btn text @click="dialog01 = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/(팝업)개인 정보-->
  </v-container>
</template>
<script>
import { findUserId, changeTempPassword, isTerminateMemberCheck, internalContract } from '@/api/user'

export default {
  name: 'login',
  components: {
  },
  filters: {
  },
  data () {
		const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('비밀번호는 최소 8자리 이상이어야합니다.'))
      } else {
        callback()
      }
    }
    return {
      userjoinform: process.env.VUE_APP_USER_JOIN,
			loginForm: {
        username: '',
        password: ''
      },
      nextPage: '',
      saveid: {
        type: []
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message: '아이디를 입력해 주세요.' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
			},
			findUsrId: '',
			FindIdInfo: {
        userName: '',
        userEmail: ''
      },
      FindPassInfo: {
        userId: '',
        userName: '',
        userEmail: ''
      },
			nameRules: [
				v => !!v || '아이디를 입력해 주세요.'
			],
			passwordRules:[
				v => !!v || '비밀번호를 입력해 주세요.',
        v => (v && v.length > 5) || '비밀번호는 최소 6자리 이상이어야합니다.',
        v => !/\s/.test(v) || '비밀번호에 공백이 있습니다. 공백을 제거해주세요.'
			],
			emailRules: [
				v => !!v || '이메일을 입력해 주세요.',
				v => /.+@.+\..+/.test(v) || '이메일 형식을 확인 해주세요.',
			],
      passwordType: 'password',
      loading: false,
      showDialog: false,
      // 개인정보
      dialog01: false,
			tab: null,
			hidden: false
    }
  },
  created () {
  },
  mounted () {
    // 동원 내부 계약인 경우 쿼리 파라미터가 있음.
    if (this.$route.query.contNo !== undefined) {
      this.$store.dispatch('LogOut').then(() => {
        console.log("동원 내부 계약인 경우 쿠키 제거");
      })
    }

    this.track()
    // window.addEventListener('hashchange', this.afterQRScan)
		var userInputId = this.getCookie('userInputId')
    if (userInputId === '') {
      this.saveid = false
    } else {
      this.saveid = true
      this.loginForm.username = userInputId
    }
    this.nextPage = ''
    if (this.$route.params.nextPage !== undefined) {
      this.nextPage = this.$route.params.nextPage
    } else if (this.$route.query.nextPage !== undefined) {
      this.nextPage = this.$route.query.nextPage
    }
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/login'
      })
    },
    setCookie (cookieName, value, exdays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + exdays)
      var cookieValue = escape(value) + ((exdays === null) ? '' : '; expires=' + exdate.toGMTString())
      document.cookie = cookieName + '= ' + cookieValue
    },
    deleteCookie (cookieName) {
      var expireDate = new Date()
      expireDate.setDate(expireDate.getDate() - 1)
      document.cookie = cookieName + '= ' + '; expires=' + expireDate.toGMTString()
		},
		getCookie (cookieName) {
      cookieName = cookieName + '='
      var cookieData = document.cookie
      var start = cookieData.indexOf(cookieName)
      var cookieValue = ''
      if (start !== -1) {
        start += cookieName.length
        var end = cookieData.indexOf(';', start)
        if (end === -1) end = cookieData.length
        cookieValue = cookieData.substring(start, end)
      }
      return unescape(cookieValue)
		},
    goJoin () {
      this.$router.push({ name: 'join' })
		},
		submitIdForm () {
			var valid = this.$refs.FindIdInfo.validate()
			if (valid) {
				this.$refs.loading.start('입력 정보 확인 중')
				this.$nextTick(() => {
					findUserId(JSON.stringify({ user: this.FindIdInfo })).then(Response => {
						if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
							this.$refs.loading.end()
							this.findUsrId = Response.rdata.userid
						} else {
							this.$refs.loading.end()
							var msg = ''
							if (Response.rdata === undefined) {
								msg = Response.message
							} else {
								msg = Response.rdata.message
							}
							this.$refs.confirm.open('alert', '아이디 찾기', msg)
						}
					}).catch(() => {
						this.$refs.loading.end()
					})
				})
			}
    },
    submitPassForm () {
			var valid = this.$refs.FindPassInfo.validate()
			if (valid) {
				this.$refs.loading.start('입력 정보 확인 중')
				this.$nextTick(() => {
					changeTempPassword(JSON.stringify({ user: this.FindPassInfo })).then(Response => {
						if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
							this.$refs.loading.end()
							this.$refs.confirm.open('alert', '임시 비밀번호 발급', '해당 계정의 이메일로 임시 비밀번호가 발급되었습니다.')
						} else {
							this.$refs.loading.end()
							var msg = ''
							if (Response.rdata === undefined) {
								msg = Response.message
							} else {
								msg = Response.rdata.message
							}
							this.$refs.confirm.open('alert', '임시 비밀번호 발급', msg)
						}
					}).catch(() => {
						this.$refs.loading.end()
					})
				})
			} else {
				return false
			}
    },

		handleLogin () {
			var valid = this.$refs.loginForm.validate()
			if (valid) {
				this.$refs.loading.start('로그인 중입니다.')
        isTerminateMemberCheck(this.loginForm).then(response => {
          // 탈퇴회원인 경우
          if(response.rdata.rcode === 30401) {
            this.$refs.confirm.open('alert', '로그인', response.rdata.getMessage);
            this.$refs.loading.end()
            return;
          }

          this.$store.dispatch('Login', this.loginForm).then(() => {
            this.$refs.loading.end()
            if (this.saveid) {
              this.setCookie('userInputId', this.loginForm.username, 7)
            } else {
              this.deleteCookie('userInputId')
            }
            // location.reload()
            /*
            if (this.nextPage !== '') {
              // intent를 이용하여 argument 추가 여부를 분기처리
              // intent true인 경우 params을 추가하여 다음 화면 진입
              if (this.$route.query !== undefined && this.$route.query.intent === 'true') {
                this.$router.push({
                  name: this.nextPage,
                  params: this.$route.query
                })
              } else {
                this.$router.push({ name: this.nextPage })
              }
            } else {
              this.$router.push({ name: 'dashboard' })
            }
            */

            // 동원 내부 계약인 경우.
            let contNo = '';
            let contSeq = '';
            let receiverRegNo = '';

            if (this.$route.query.contNo !== undefined) {
              contNo = this.$route.query.contNo;

              if (this.$route.query.contSeq !== undefined)
                contSeq = this.$route.query.contSeq;

              if (this.$route.query.receiverRegNo !== undefined)
                receiverRegNo = this.$route.query.receiverRegNo;

              if(contNo.startsWith("DW")) {
                let params = {
                  "contNo" : contNo,
                  "receiverRegNo" : receiverRegNo
                }
                internalContract(params).then(response => {
                  if(response.rdata.internalContract) {
                    this.$router.push({
                      name: 'contractDetail',
                      params: { contractSeq: contSeq *1 }
                    })
                  }
                });
              }
            }else {
              window.location = process.env.VUE_APP_RESPONSE_URL + "/main"
            }

          }).catch(() => {
            this.$refs.confirm.open('alert', '로그인', '아이디와 패스워드를 확인해주세요.')
            this.$refs.loading.end()
          })
        }).catch(() => {
          this.$refs.loading.end()
        })


			} else {
				return false
			}
		}
  }
}
</script>
<style scoped>
</style>
